import React from 'react'
import { useIntl } from 'react-intl'

import { useAppDispatch } from 'hooks/reduxHooks'
import { accountAccessShowLogin } from 'actions/UiActions'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import TextLink from 'LuxKit/TextLink'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'

const HeroButton = styled.div`
  text-align: center;
  margin-top: ${rem(16)};
`

const SecondaryText = styled.div`
  text-align: center;
  margin-top: ${rem(16)};
`

const InnerSection = styled(LayoutContainer).attrs<any>({
  size: 'md',
})`
  padding: ${rem(32)} ${rem(40)};

  ${mediaQueryUp.desktop} {
    padding: ${rem(64)} ${rem(32)};
  }
`

interface Props {
  hash: string
  headerText?: string
  secondaryText?: string
}

function Login({ headerText, secondaryText, hash }: Props) {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  return <Pane id={hash}>
    <PaneBody>
      <InnerSection>
        {headerText && <Heading variant="heading5" align="center">
          {headerText}
        </Heading>}
        <Heading variant="heading3" align="center">
          {intl.formatMessage({ id: 'IitZPU2xhV', defaultMessage: 'Sign up to become a Luxury Escapes member today!', description: 'Heading encouraging users to sign up on the hub page login section' })}
        </Heading>
        <SecondaryText>
          <BodyText variant="large" weight="bold" as="span">{intl.formatMessage({ id: 'uc0FE1Xxwp', defaultMessage: 'Already a member?', description: 'Label for existing members on the hub page login section' })}</BodyText>
          {secondaryText && <>
            &nbsp;
            <BodyText variant="large" as="span">{secondaryText}</BodyText>
          </>}
        </SecondaryText>
        <HeroButton>
          <TextButton kind="primary" onClick={() => dispatch(accountAccessShowLogin())}>
            {intl.formatMessage({ id: '2e7Jw99uhA', defaultMessage: 'Log in to my account', description: 'Button to log in to existing account on hub page login section' })}
          </TextButton>
        </HeroButton>
        <HeroButton>
          <TextLink onClick={() => dispatch(accountAccessShowLogin())}>
            {intl.formatMessage({ id: '5Z7ZP4WKWp', defaultMessage: 'or create an account', description: 'Link to create a new account on hub page login section' })}
          </TextLink>
        </HeroButton>
      </InnerSection>
    </PaneBody>
  </Pane>
}

export default Login
